module.exports = __webpack_public_path__ + "assets/img/1.87f6d8a9.png";